<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M18.7 12q-.2-3.9-3.4-5.8-.7-.2-1 .4-.2.8.4 1.2a5 5 0 0 1 0 8.4q-.6.5-.5 1.2.4.6 1.1.4 3.2-2 3.4-5.8m-3.4 0q0-1.6-1.3-2.7-.7-.2-1 .4-.2.7.3 1.3a2 2 0 0 1 0 2q-.5.6-.3 1.3t1 .4q1.3-1 1.3-2.7m1.3-8.9a1 1 0 0 0-1 .4q-.3.8.4 1.2a8.3 8.3 0 0 1 0 14.6q-.7.4-.5 1.2.4.7 1.1.4a10 10 0 0 0 0-17.8M3 7.8a1 1 0 0 0-1 1v6.4q0 .9 1 1h2q.3 0 .6.3l3.9 3.8a1 1 0 0 0 1.7-.7V4.4a1 1 0 0 0-1.7-.7L5.6 7.5l-.7.3z"
    />
  </svg>
</template>
